import React, { createContext, useMemo, useState } from 'react'

export const PushDrawerContext = createContext()

export function PushDrawerProvider({ children }) {
    const [pushDrawerConfig, setPushDrawerConfig] = useState({})
    const contextValue = useMemo(() => {
        return {
            setPushDrawerConfig,
            pushDrawerConfig,
            pushPortalId: 'push-drawer-content-portal',
        }
    }, [pushDrawerConfig])

    return (
        <PushDrawerContext.Provider value={contextValue}>
            {children}
        </PushDrawerContext.Provider>
    )
}
